import { all } from 'redux-saga/effects'
import { watchFetchProducts } from '../modules/products/saga'
import watchThemeChanger from '../modules/theme/sagas'
import watchFetchUser from '../modules/auth/sagas'

export default function* rootSaga() {
  yield all([watchThemeChanger(), watchFetchProducts(), watchFetchUser()])
}
